// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as AttachmentADefault } from '../../../../../ui-v3/src/assets/icons/default/editor/attachment-a.svg?react';
import { ReactComponent as AttachmentASolid } from '../../../../../ui-v3/src/assets/icons/solid/editor/ATTACHMENT-A.svg?react';
import { createIcons } from '../../Icon';
const AttachmentAIcon = /* @__PURE__ */ createIcons('AttachmentA', {
    default: AttachmentADefault,
    solid: AttachmentASolid
});
AttachmentAIcon.supportedTypes = [
    'default',
    'solid'
];
AttachmentAIcon.category = 'editor';
export default AttachmentAIcon;
